


































































































import LineChart from "@/components/chart/LineChart.vue";
import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import xlsx from "xlsx";
import { GetMetersReq, meters } from "@/api/meter";
import { RouteConfig } from "vue-router";
import {
  ResCode,
  PagingReq,
  Meter,
  RsNetwork,
  RsNetworkMeter,
} from "@/api/baseDefine";
import { ElTree, TreeData } from "element-ui/types/tree";
import { UserModule } from "@/store/modules/user";
import { ElStep } from "element-ui/types/step";
import { queryUser, QueryUserReq, UserReq, users } from "../../api/user";
import { getAddresses, GetAddress } from "../../api/address";
import { GetMeterReq, getMeterData, History } from "../../api/home";
import { QueryMeterCostReq } from "../../api/meterCost";
import { Getter } from "vuex";
import { ElForm } from "element-ui/types/form";
import { globalData } from "@/utils/config";
import { ParseAddress } from "@/utils/parseAddress";
import en from "../../lang/lang/en";
import {
  AddRsNetworkReq,
  addRsNetwork,
  GetRsNetworksReq,
} from "@/api/rsNetwork";
/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({
  components: {
    Pagination,
    LineChart,
  },
})
export default class AddRsNetwork extends Vue {
  private loading = false;
  private activeIndex = 0;
  private mapIndexRsNetworkMeter: Map<number, RsNetworkMeter> = new Map();
  private selectMeters: Meter[] = [];
  private mapMeterID: Map<string, number> = new Map();
  private selectBaudRates: number[] = [9600, 19200];
  private newRsNetwork: RsNetwork = <RsNetwork>{
    rsNetworkMeters: [
      <RsNetworkMeter>{
        index: 0,
        meter: <Meter>{
          id: 0,
        },
      },
    ],
  };
  private listQuery: GetMetersReq = <GetMetersReq>{
    page: 1,
    pageSize: 10,
  };
  private indexArray: number[] = [];

  public async queryMeter(query: string) {
    console.log("queryMeter 111", this.newRsNetwork);
    if (query !== null && query !== undefined) {
      this.loading = true;
      let req: GetMetersReq = <GetMetersReq>{};
      req.meter = <Meter>{};
      req.meter.meterID = query;
      req.meter.meterTypeID = 2;
      if (this.activeIndex == 0) {
        req.meter.subMeterTypeIndex = 2;
      } else {
        req.meter.subMeterTypeIndex = 3;
      }
      const res = await meters(req);
      if (
        res.code === ResCode.SUCCESS &&
        !!res.data &&
        !!res.data.meters &&
        !!res.data.meters.list
      ) {
        this.selectMeters = [];

        for (let i = 0; i < res.data.meters.list.length; i++) {
          let add = true;
          for (let j = 0; j < this.newRsNetwork.rsNetworkMeters.length; j++) {
            if (
              res.data.meters.list[i].meterID ==
              this.newRsNetwork.rsNetworkMeters[j].meter.meterID
            ) {
              add = false;
              break;
            }
          }
          if (add) {
            this.selectMeters.push(res.data.meters.list[i]);
          }
        }

        for (let item of this.selectMeters) {
          this.mapMeterID[item.meterID] = item.id;
        }
        this.loading = false;
      }
    }
  }

  public async addRsNetwork() {
    let req: AddRsNetworkReq = <AddRsNetworkReq>{};
    let rsNetworkMeters: RsNetworkMeter[] = [];
    req.rsNetwork = this.newRsNetwork;
    console.log("addRsNetwork start", req);
    for (let item of req.rsNetwork.rsNetworkMeters) {
      if (!!item.meter && !!item.meter.meterID) {
        item.meter.id = this.mapMeterID[item.meter.meterID];
        rsNetworkMeters.push(item);
      }
    }
    console.log("addRsNetwork end", rsNetworkMeters);
    if (
      !req.rsNetwork.name ||
      !req.rsNetwork.baudRate ||
      !req.rsNetwork.startIndex ||
      !req.rsNetwork.endIndex ||
      rsNetworkMeters.length <= 0
    ) {
      alert(this.$t("notification.pleaseInputAll").toString());
      return;
    }
    req.rsNetwork.rsNetworkMeters = rsNetworkMeters;
    const res = await addRsNetwork(req);
    if (res.code === ResCode.SUCCESS) {
      this.$router.push("/meter/rsnetwork");
    }
  }

  public onSelectMeterVisible(b: boolean) {
    console.log("onSelectMeterVisible", b);
    if (b) {
      this.queryMeter("");
    }
  }

  public onSelectMeterFocus(index: number) {
    console.log("onSelectMeterFocus", index);
    this.activeIndex = index;
  }
  private onIndexChange() {
    let rsNetworkMeters = this.newRsNetwork.rsNetworkMeters;
    this.newRsNetwork.rsNetworkMeters.splice(1, rsNetworkMeters.length - 1);
    let start = this.newRsNetwork.startIndex;
    let end = this.newRsNetwork.endIndex;
    console.log("onIndexChange", start, end);
    if (!start || !end || start > end) {
      return;
    }
    for (let i = start; i <= end; i++) {
      let rsNetworkMeter = this.mapIndexRsNetworkMeter[i];
      if (!rsNetworkMeter) {
        rsNetworkMeter = <RsNetworkMeter>{
          index: i,
          meter: <Meter>{
            id: 0,
          },
        };
        this.mapIndexRsNetworkMeter[i] = rsNetworkMeter;
      }
      this.newRsNetwork.rsNetworkMeters.push(rsNetworkMeter);
    }
  }
  public reset() {
    this.newRsNetwork = <RsNetwork>{};
  }

  private created() {
    this.indexArray = [];
    this.indexArray.push(0);
  }

  public dataRules = {
    name: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    // networkBaudRate: [
    //   { required: true, trigger: "blur", validator: this.validateNotNull }
    // ],
    // numberOfSlaveNumber: [
    //   { required: true, trigger: "blur", validator: this.validateNotNull }
    // ]
  };

  private validateNotNull(rule: any, value: string, callback: any) {
    if (!value || value.length <= 0) {
      callback(new Error(this.$t("validate.valueNotNull").toString()));
    } else {
      callback();
    }
  }

  private validateNumber(rule: any, value: string, callback: any) {
    if (!value || value.length <= 0) {
      callback(new Error(this.$t("validate.valueNotNull").toString()));
    } else if (isNaN(Number(value))) {
      callback(new Error(this.$t("validate.onlyNumberPermission").toString()));
    } else {
      callback();
    }
  }

  public async handleEditMeter() {
    (this.$refs.form as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.newMeter();
      } else {
        return false;
      }
    });
  }

  public async newMeter() {
    console.log(this.newRsNetwork);
  }
}
